import "./LinkProjectModal.css";

import { SelectData } from "../../../../../models";
import { ServiceError } from "../../../../../service/Shared";
import { getErrorMessageFromCode } from "../../../../../service/ValidationErrorFormatter";
import { Autocomplete, Button, Column, ErrorBox, Modal, Row, TextInput } from "../../../../../widget";

interface LinkProjectModalProps {
  show: boolean;
  onClose: () => void;
  projectOptions: SelectData;
  projectUuid: string | null;
  companyRole: string;
  setCompanyRole: (value: string) => void;
  setProjectUuid: (value: string) => void;
  fetchProjects: (value: string) => void;
  errors: ServiceError[];
  isSaving: boolean;
  onCreate: () => Promise<void>;
}

export const LinkProjectModal = ({
  show,
  onClose,
  projectOptions,
  projectUuid,
  companyRole,
  setCompanyRole,
  setProjectUuid,
  fetchProjects,
  errors,
  isSaving,
  onCreate,
}: LinkProjectModalProps): JSX.Element => {
  const canCreate = Boolean(projectUuid) && companyRole.trim().length > 0 && !isSaving;

  return (
    <Modal show={show} title="Link project" onClose={onClose} className="LinkProjectModal">
      {errors.length > 0 && (
        <Row spacingV="m" justify="center">
          <Column span={8}>
            <ErrorBox
              title="Please solve the below issues before saving"
              text={errors.map((error: ServiceError) => getErrorMessageFromCode(error.message))}
            />
          </Column>
        </Row>
      )}
      <Row spacingV="ll" justify="center">
        <Column span={6}>
          <div className="LinkProjectModalField">
            <Autocomplete
              label="Project"
              placeholder="Search"
              data={projectOptions}
              onTypeSearch={fetchProjects}
              onSelect={(value) => setProjectUuid(value)}
              corners="rounded"
            />
          </div>
        </Column>
      </Row>
      <Row spacingV="ll" justify="center">
        <Column span={6}>
          <TextInput
            label="Company role"
            name="companyRole"
            value={companyRole}
            onChange={setCompanyRole}
            placeholder="Enter company role"
          />
        </Column>
      </Row>
      <Row justify="center">
        <div className="LinkProjectModalButtons">
          <Button text="Create" onClick={onCreate} corners="rounded" disabled={!canCreate} isLoading={isSaving} />
          <Button text="Cancel" onClick={onClose} variant="secondary" corners="rounded" />
        </div>
      </Row>
    </Modal>
  );
};
